import { createRefsContext } from '@/providers'

export const { Provider: SlidesRefsProvider, useRefs: useSlidesRefs } =
  createRefsContext<HTMLDivElement, { imgHeight: number }>()
